



















import { Vue, Component } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import Main from './containers/Main.vue';
import Sidebar from './containers/Sidebar.vue';
import TableModals from './containers/TableModals.vue';
import RecordModals from './containers/RecordModals.vue';
import MasterPasswordLock from './components/MasterPasswordLock.vue';

@Component({
  name: 'app',
  components: {
    Main,
    Sidebar,
    TableModals,
    RecordModals,
    MasterPasswordLock,
  },
})
export default class App extends Vue {
  @Getter('masterPassword/isLocked') private isLocked!: boolean;
}
